import { UseFormReturnType } from '@mantine/form'
import { useModals } from '@mantine/modals'
import { useTrueToFalse } from 'hooks/utils'
import { useEffect } from 'react'
import FormButtons from './FormButtons'

type Props<FormValues extends Record<string, any>> = {
  children: React.ReactNode
  form: UseFormReturnType<FormValues>
  onSubmit: (values: FormValues) => void
  onCancel: () => void
  submitText: string
  disabledReason?: string | null
  withButtons?: boolean
}

export default function Form<FormValues extends Record<string, any>>({
  children,
  form,
  onSubmit,
  onCancel,
  submitText,
  disabledReason,
  withButtons,
}: Props<FormValues>) {
  const isSubmitted = useTrueToFalse(form.submitting)
  const { modals, updateContextModal } = useModals()

  useEffect(() => {
    updateContextModal({
      modalId: modals[modals.length - 1]?.id,
      onClose: () => {
        form.reset()
      },
      transitionProps: { exitDuration: 0 },
    })
  }, [])

  useEffect(() => {
    if (isSubmitted) {
      ;(document.activeElement as HTMLElement | null)?.blur()
    }
  }, [isSubmitted])

  return (
    <form onSubmit={form.onSubmit((values) => onSubmit(values))} style={{ position: 'relative' }}>
      {children}
      {withButtons !== false && (
        <FormButtons
          onCancel={onCancel}
          submitText={submitText}
          loading={form.submitting}
          disabledReason={disabledReason}
        />
      )}
    </form>
  )
}
